import { COLOR_PICKER_SWATCHES } from 'sonata-react-components';
import { isHexColor } from 'sonata-static-storage/lib/helpers/hexColor.helpers';

/** Palette colour of a flight / line item by its position (cycles the 8 ColorPicker swatches). */
export const getPaletteColor = (index: number): string => COLOR_PICKER_SWATCHES[index % COLOR_PICKER_SWATCHES.length];

/** Flights without a valid colour get the palette colour of their index (never `''`). */
export const withFlightColors = <T extends { color?: string } | undefined>(flights: T[]): T[] =>
  flights.map((flight, index) =>
    !flight || (flight.color && isHexColor(flight.color)) ? flight : { ...flight, color: getPaletteColor(index) }
  );
